import ReportLine from 'models/ReportLineModel';

import { BalanceSheetClassificationPriorities } from 'enums/balance-sheet-account-types';

export default class BalanceSheetReportLines {
  static deserialize(lines = []) {
    const priority = (a) => BalanceSheetClassificationPriorities[a.classification];

    return lines
      .map(ReportLine.deserialize)
      .filter(priority)
      .sort((a, b) => (priority(a) > priority(b) ? -1 : 1));
  }
}
